/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationSharedStatusReasonList200,
  GetApiV1CourseregistrationSharedStatusReasonList401,
  GetApiV1CourseregistrationSharedStatusReasonList500,
  GetApiV1CourseregistrationSharedStatusReasonListQueryParams,
  GetApiV1CourseregistrationSharedStatusReasonListQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedStatusReasonList.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";
import { eEnrollmentStatusSchema } from "../eEnrollmentStatusSchema.ts";

export const getApiV1CourseregistrationSharedStatusReasonListQueryParamsSchema =
  z
    .object({
      status: z.optional(
        z
          .lazy(() => eEnrollmentStatusSchema)
          .describe(
            "1 = PaymentSelection | 2 = PaymentPending | 3 = ApprovalPending | 4 = Approved | 5 = Activating | 6 = Active | 7 = Transferred | 8 = TransferredInRegistration | 9 = Canceled | 10 = CanceledInRegistration | 11 = Rejected | 12 = FinishedWithPendencies | 13 = Finished | 14 = FinishedWithMonograph | 15 = FinishedWithCertificate | 16 = Blocked | ",
          ),
      ),
      companyId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1CourseregistrationSharedStatusReasonListQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationSharedStatusReasonList200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedStatusReasonList200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationSharedStatusReasonList401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedStatusReasonList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationSharedStatusReasonList500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedStatusReasonList500>;

export const getApiV1CourseregistrationSharedStatusReasonListQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationSharedStatusReasonList200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedStatusReasonListQueryResponse>;
